import { Navigate } from 'react-router-dom'
import { SCHOOL_LEGAL_PAGE_PATH } from '../constants/schoolLegal'

/** @deprecated Use /legal — combined Terms & Privacy for yoga schools. */
const TermsOfService = () => <Navigate to={SCHOOL_LEGAL_PAGE_PATH} replace />

export default TermsOfService
